"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var fetchAndPopulateItems_1 = require("@features/ItemCommon/service/fetchAndPopulateItems");
var feedback_1 = require("@common/services/feedback");
var moderationQueue_1 = require("@common/services/moderationQueue");
var permission_1 = require("@utils/permission");
var ItemWithRevision_1 = __importDefault(require("@features/QueuePage/components/ItemWithRevision"));
var updateValues_1 = require("@features/QueuePage/util/updateValues");
var react_i18next_1 = require("react-i18next");
var notifier_1 = __importDefault(require("@utils/notifier"));
var i18next_1 = __importDefault(require("i18next"));
var util_1 = require("@features/ItemCommon/service/util");
var clsx_1 = __importDefault(require("clsx"));
var settings_1 = require("@/react-app/common/services/settings");
var KeyboardModal_1 = __importDefault(require("./components/KeyboardModal"));
var useLeftRightArrowNavigation_1 = require("@/react-app/common/hooks/useLeftRightArrowNavigation");
var refusalReasons_1 = require("@/react-app/common/services/refusalReasons");
var Button_1 = __importDefault(require("@/react-app/common/button/Button"));
var submitItems_1 = require("../ItemCommon/service/submitItems");
var apiService_1 = require("@/react-app/common/services/apiService");
var scrollToWithCallback_1 = require("@/react-app/common/utils/scrollToWithCallback");
var navigationBarHeight = 100;
var bottomBarHeight = 50;
// IntersectionObserver threshold is not working as expected
// for example when scrolling to the top of the page, the first element is not intersecting
var extraHeight = 200;
// const rootMargin = `-${navigationBarHeight}px 0px -${bottomBarHeight}px 0px`;
var rootMargin = "-".concat(navigationBarHeight, "px 0px -").concat(bottomBarHeight + extraHeight, "px 0px");
function default_1(_a) {
    var domain = _a.domain, queueId = _a.queueId, angularJsDependencies = _a.angularJsDependencies;
    var _b = (0, refusalReasons_1.useGetRefusalReasonsQuery)(domain), refusalReasonResults = _b.data, decisionSetLoading = _b.isLoading, decisionSetError = _b.isError, refetchRefusalReasons = _b.refetch;
    var _c = (0, feedback_1.useGetFeedbackQuery)(domain), feedbackSetArray = _c.data, feedbackSetLoading = _c.isLoading, feedbackSetError = _c.isError, refetchFeedback = _c.refetch;
    var _d = (0, moderationQueue_1.useGetQueuesQuery)(domain), queues = _d.data, isQueueLoading = _d.isLoading, isQueueError = _d.isError, refetchQueues = _d.refetch;
    var _e = (0, settings_1.useGetManualSettingQuery)(domain), manualSettings = _e.data, isManualLoading = _e.isLoading, isManualError = _e.isError, refetchManualSettings = _e.refetch;
    // in Angular version the domain  /categories api and /types api are called to get the categories and types
    // We didn't implement it because they are not used
    var t = (0, react_i18next_1.useTranslation)().t;
    var isLoading = decisionSetLoading || feedbackSetLoading || isQueueLoading || isManualLoading;
    var isError = decisionSetError || feedbackSetError || isQueueError || isManualError;
    var refetchData = function () {
        refetchManualSettings();
        refetchFeedback();
        refetchQueues();
        refetchRefusalReasons();
    };
    if (!isLoading && isError) {
        return (react_1.default.createElement("div", { className: "eva-has-loading-jobs-error" },
            react_1.default.createElement("h2", null, t('MODERATION.QUEUE_VIEW.FAILED_TO_LOAD')),
            react_1.default.createElement(Button_1.default, { onClick: function () { return refetchData(); }, text: t('MODERATION.SINGLE_ITEM_VIEW.RETRY_BUTTON'), type: "primary" })));
    }
    if (isLoading) {
        return (react_1.default.createElement("div", { className: "loading-tracker" },
            react_1.default.createElement("div", { className: "page-loading-icon" })));
    }
    if (manualSettings && feedbackSetArray && queues && refusalReasonResults) {
        return (react_1.default.createElement(QueuePageSub, { domain: domain, angularJsDependencies: angularJsDependencies, manualSettings: manualSettings, feedbackSetArray: feedbackSetArray, queues: queues, queueId: queueId, refusalReasonResults: refusalReasonResults }));
    }
}
exports.default = default_1;
function QueuePageSub(_a) {
    var _this = this;
    var _b;
    var domain = _a.domain, queueId = _a.queueId, angularJsDependencies = _a.angularJsDependencies, manualSettings = _a.manualSettings, feedbackSetArray = _a.feedbackSetArray, queues = _a.queues, refusalReasonResults = _a.refusalReasonResults;
    var _c = __read((0, react_1.useState)(false), 2), keyboardModalOpen = _c[0], setKeyboardModalOpen = _c[1];
    var _d = __read((0, react_1.useState)(false), 2), submitLoading = _d[0], setSubmitLoading = _d[1];
    var _e = __read((0, react_1.useState)(false), 2), isFetchingItemsLoading = _e[0], setIsFetchingItemsLoading = _e[1];
    var _f = __read((0, react_1.useState)(false), 2), isFetchingItemsError = _f[0], setIsFetchingItemsError = _f[1];
    var t = (0, react_i18next_1.useTranslation)().t;
    var _g = __read((0, react_1.useState)([]), 2), items = _g[0], setItems = _g[1];
    var _h = __read((0, react_1.useState)([]), 2), itemsGroup = _h[0], setItemsGroup = _h[1];
    var itemsRef = (0, react_1.useRef)([]);
    var evaJobContainerRef = (0, react_1.useRef)(null);
    var submitButtonRef = (0, react_1.useRef)(null);
    var isNaturalScroll = (0, react_1.useRef)(true);
    var _j = __read((0, useLeftRightArrowNavigation_1.useLeftRightArrowNavigation)(evaJobContainerRef, isNaturalScroll), 2), focusedElementIndex = _j[0], setFocusedElementIndex = _j[1];
    var focusableElements = ((_b = evaJobContainerRef.current) === null || _b === void 0 ? void 0 : _b.querySelectorAll('.eva-keyboard-focusable')) || [];
    var totalItems = itemsGroup.length;
    var totalFocusableElements = focusableElements.length;
    // on init we will have 0 focusableElements and 0 items
    var focusableElementsPerGroup = totalItems === 0 || totalFocusableElements === 0 ? 0 : Math.floor((totalFocusableElements - 1) / totalItems);
    var focusableElementsPerGroupRef = (0, react_1.useRef)(focusableElementsPerGroup);
    var getFocusedGroup = function (focusedElementIndex, focusableElementsPerGroup) {
        if (focusableElementsPerGroup < 0)
            return 0;
        if (focusedElementIndex === focusableElements.length - 1)
            return itemsGroup.length - 1;
        return Math.floor(focusedElementIndex / focusableElementsPerGroup);
    };
    var focusedJobGroup = getFocusedGroup(focusedElementIndex, focusableElementsPerGroup);
    (0, react_1.useEffect)(function () {
        // focusableElements.length - 1 => because the last element is the submit button
        focusableElementsPerGroupRef.current = focusableElementsPerGroup;
    }, [focusableElements, itemsGroup]);
    var scrollToElement = function (top) {
        isNaturalScroll.current = false;
        (0, scrollToWithCallback_1.scrollToWithCallback)(top, 'smooth', function () {
            isNaturalScroll.current = true;
        });
    };
    var goToRef = function (index) {
        var _a;
        if (!itemsRef.current[index])
            return;
        var focusableElements = ((_a = evaJobContainerRef.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll('.eva-keyboard-focusable')) || [];
        var focusableElementsPerGroup = Math.floor((focusableElements.length - 1) / itemsGroup.length);
        var newFocusedElementIndex = index * focusableElementsPerGroup;
        var elementTop = itemsRef.current[index].offsetTop;
        var jobMarginTop = 40;
        var top = elementTop - jobMarginTop;
        scrollToElement(top);
        setFocusedElementIndex(newFocusedElementIndex);
    };
    var settings = (0, react_1.useMemo)(function () {
        return {
            isPreApproved: manualSettings.default_preapprove,
            displayPerPage: manualSettings.display_per_page,
            template: manualSettings.template,
            editPermissions: (0, permission_1.getEditPermissions)(manualSettings),
        };
    }, [manualSettings]);
    var updateItemGroups = function (jobGroups) {
        setItemsGroup(jobGroups);
    };
    var refusalReasons = refusalReasonResults === null || refusalReasonResults === void 0 ? void 0 : refusalReasonResults.results;
    var updateItemCurrent = function (item, newCurrent) {
        return updateItemGroups((0, updateValues_1.updateItemCurrentGroup)(itemsGroup, item, newCurrent));
    };
    var updateItemCustomerSpecific = function (item, newCustomerSpecific) {
        return updateItemGroups((0, updateValues_1.updateItemCustomerSpecificGroup)(itemsGroup, item, newCustomerSpecific));
    };
    var updateFeedback = function (item, selectedFeedback) {
        return updateItemGroups((0, updateValues_1.updateFeedbackGroup)(itemsGroup, item, selectedFeedback));
    };
    var updateModerationNotes = function (item, notes) {
        return updateItemGroups((0, updateValues_1.updateModerationNotesGroup)(itemsGroup, item, notes));
    };
    var updateDecision = function (job, decision) {
        return updateItemGroups((0, updateValues_1.updateDecisionGroup)(itemsGroup, job, decision));
    };
    var setJob = function (job) {
        updateItemGroups((0, updateValues_1.updateJobGroup)(itemsGroup, job));
    };
    // can contain null values
    var decisionTypeArray = (0, react_1.useMemo)(function () {
        return itemsGroup === null || itemsGroup === void 0 ? void 0 : itemsGroup.map(function (jobGroup) { var _a, _b; return (_b = (_a = jobGroup === null || jobGroup === void 0 ? void 0 : jobGroup.jobs[0]) === null || _a === void 0 ? void 0 : _a.selectedDecision) === null || _b === void 0 ? void 0 : _b.type; });
    }, [itemsGroup]);
    // when decision are preapprove, submit button will be disabled if the moderator did not scroll to see them all disabled
    var hasScrolledToLastAd = focusedJobGroup === itemsGroup.length - 1;
    var decisionMadeCount = decisionTypeArray === null || decisionTypeArray === void 0 ? void 0 : decisionTypeArray.filter(function (decisionType) { return decisionType !== null; }).length;
    var isSubmitButtonDisabled = decisionMadeCount === 0 || (settings.isPreApproved && !hasScrolledToLastAd);
    var fetchData = function () { return __awaiter(_this, void 0, void 0, function () {
        var _a, items_1, itemsGroup_1, allJobDetailsPromises, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, 3, 4]);
                    setIsFetchingItemsLoading(true);
                    return [4 /*yield*/, (0, fetchAndPopulateItems_1.fetchAndPopulateItems)(domain, settings.displayPerPage, queueId, refusalReasons, feedbackSetArray, settings.isPreApproved, (0, util_1.getCurrentQueueName)(queues, queueId))];
                case 1:
                    _a = _b.sent(), items_1 = _a.items, itemsGroup_1 = _a.itemsGroup, allJobDetailsPromises = _a.allJobDetailsPromises;
                    setItems(items_1); // show data immediately
                    allJobDetailsPromises.then(function () {
                        setItems(__spreadArray([], __read(items_1), false)); // update item once job details and notices have loaded
                    });
                    itemsGroup_1 && updateItemGroups(itemsGroup_1);
                    return [3 /*break*/, 4];
                case 2:
                    error_1 = _b.sent();
                    console.error('Failed to fetch items:', error_1); // More detailed error handling
                    setIsFetchingItemsError(true);
                    return [3 /*break*/, 4];
                case 3:
                    setIsFetchingItemsLoading(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var onSubmit = function () { return __awaiter(_this, void 0, void 0, function () {
        var error_2;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!(itemsGroup && refusalReasons && feedbackSetArray && queues && settings)) return [3 /*break*/, 6];
                    setSubmitLoading(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 4, 5, 6]);
                    return [4 /*yield*/, (0, submitItems_1.submitItems)(domain, itemsGroup, (0, util_1.getCurrentQueueName)(queues, queueId), queueId)];
                case 2:
                    _b.sent();
                    return [4 /*yield*/, fetchData()];
                case 3:
                    _b.sent();
                    // reset itemsRef.current
                    itemsRef.current = [];
                    // Focus the first element after submit
                    if (decisionTypeArray && decisionTypeArray.length > 0) {
                        setFocusedElementIndex(0);
                    }
                    return [3 /*break*/, 6];
                case 4:
                    error_2 = _b.sent();
                    if ((0, apiService_1.isApiError)(error_2)) {
                        notifier_1.default.error(((_a = error_2.data) === null || _a === void 0 ? void 0 : _a.message) || i18next_1.default.t('MODERATION.QUEUE_VIEW.FAILED_TO_SUBMIT'));
                    }
                    return [3 /*break*/, 6];
                case 5:
                    setSubmitLoading(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    (0, react_1.useEffect)(function () {
        fetchData();
    }, [domain, settings.displayPerPage, queueId, refusalReasons, feedbackSetArray, settings.isPreApproved, queues]);
    var addItemRef = function (element) {
        if (element && !itemsRef.current.includes(element)) {
            itemsRef.current.push(element);
        }
    };
    var observerCallback = function (entries) {
        entries.forEach(function (entry) {
            // console.log('isNaturalScroll', isNaturalScroll.current);
            // we only want to set the focusedElementIndex when the user scrolls naturally
            if (entry.isIntersecting && isNaturalScroll.current === true) {
                var index = itemsRef.current.indexOf(entry.target);
                if (index !== -1) {
                    // we have exactly focusableElementsPerGroup focusable elements per group
                    setFocusedElementIndex(index * focusableElementsPerGroupRef.current);
                }
            }
        });
    };
    // thresholds was used in Angular version
    // const thresholds = Array.from(Array(10).keys()).map((i) => i * 0.1);
    (0, react_1.useEffect)(function () {
        if ((itemsGroup === null || itemsGroup === void 0 ? void 0 : itemsGroup.length) === 0 || itemsRef.current.length === 0)
            return;
        var options = {
            rootMargin: rootMargin,
            // threshold: 0.6, // 0.5 means when 50% of the element is visible
        };
        var observer = new IntersectionObserver(observerCallback, options);
        itemsRef.current.forEach(function (ref) {
            if (ref) {
                observer.observe(ref);
            }
        });
        return function () { return observer.disconnect(); };
    }, [itemsGroup, itemsRef.current]);
    if (!isFetchingItemsLoading && isFetchingItemsError) {
        return (react_1.default.createElement("div", { className: "eva-has-loading-jobs-error" },
            react_1.default.createElement("h2", null, t('MODERATION.QUEUE_VIEW.FAILED_TO_LOAD'))));
    }
    if (isFetchingItemsLoading || submitLoading) {
        return (react_1.default.createElement("div", { className: "loading-tracker" },
            react_1.default.createElement("div", { className: "page-loading-icon" })));
    }
    if (!isFetchingItemsLoading && !isFetchingItemsError && items.length === 0) {
        return react_1.default.createElement("h2", { className: "empty-state" }, t('MODERATION.QUEUE_VIEW.NOTHING_TO_REVIEW'));
    }
    var getSubmitButtonTooltip = function () {
        if (settings.isPreApproved && isSubmitButtonDisabled) {
            return i18next_1.default.t('MODERATION.QUEUE_VIEW.STATUS_BAR.SUBMIT_BUTTON_DISABLED_TOOLTIP');
        }
        if (decisionMadeCount === 1) {
            return i18next_1.default.t('MODERATION.QUEUE_VIEW.STATUS_BAR.SUBMIT_BUTTON_ENABLED_TOOLTIP_REACT_ONE');
        }
        return i18next_1.default.t('MODERATION.QUEUE_VIEW.STATUS_BAR.SUBMIT_BUTTON_ENABLED_TOOLTIP_REACT_OTHERS', {
            COUNT: decisionMadeCount,
        });
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "row" },
            react_1.default.createElement("div", { className: "col-md-12" },
                react_1.default.createElement("div", { className: "eva-jobs", ref: evaJobContainerRef },
                    itemsGroup &&
                        itemsGroup.map(function (item, index) { return (react_1.default.createElement("div", { className: "item-with-revision-wrapper ".concat(focusedJobGroup === index ? 'focused' : ''), ref: addItemRef, key: index },
                            react_1.default.createElement(ItemWithRevision_1.default, { key: index, job: item.jobs[0], olderJobs: item.jobs.slice(1), domain: domain, updateItemCurrent: function (newCurrent) { return updateItemCurrent(item.jobs[0], newCurrent); }, updateItemCustomerSpecific: function (newCS) { return updateItemCustomerSpecific(item.jobs[0], newCS); }, updateFeedback: function (feedback) {
                                    updateFeedback(item.jobs[0], feedback);
                                }, setJob: setJob, updateModerationNotes: function (notes) { return updateModerationNotes(item.jobs[0], notes); }, angularJsDependencies: angularJsDependencies, isUsingImageGallery1: false, isUsingImageGallery2: false, editPermissions: settings.editPermissions, index: index, template: settings.template, disableReviewBar: false, onSelectDecision: function (decision) {
                                    decision && updateDecision(item.jobs[0], decision);
                                    // when it's the last group, scroll to the bottom and focus the submit button
                                    if (index === itemsGroup.length - 1) {
                                        // isNaturalScroll.current is true  so we will use setTimeout to make sure
                                        // the bellow setFocusedElementIndex is executed after the observerCallback setFocusedElementIndex
                                        setTimeout(function () {
                                            var _a;
                                            setFocusedElementIndex(focusableElements.length - 1);
                                            (_a = submitButtonRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                                        }, 100);
                                    }
                                    else {
                                        goToRef(index + 1);
                                    }
                                }, changeFocusedElement: function (ref) {
                                    var _a;
                                    var focusableElements = ((_a = evaJobContainerRef.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll('.eva-keyboard-focusable')) || [];
                                    var index = ref.current && Array.from(focusableElements).indexOf(ref.current);
                                    if (index && index !== -1) {
                                        setFocusedElementIndex(index);
                                    }
                                }, isFocused: focusedJobGroup === index }))); }),
                    itemsGroup && (react_1.default.createElement("div", { className: "process-bar-wrapper" },
                        react_1.default.createElement("div", { className: "process-bar-center container" },
                            react_1.default.createElement("div", { id: "queue-info" },
                                react_1.default.createElement("span", null,
                                    react_1.default.createElement("span", { className: "queue-info__label" }, "Currently moderating"),
                                    react_1.default.createElement("span", { className: "queue-info__name" }, queues && (0, util_1.getCurrentQueueName)(queues, queueId)))),
                            react_1.default.createElement("div", { id: "progress-bar-and-submit-button" },
                                react_1.default.createElement("i", { className: "implioicons-keyboard cursor-pointer", id: "open-keyboard-help", onClick: function () { return setKeyboardModalOpen(true); } }),
                                react_1.default.createElement("div", { className: "eva-jobs-progress-bar" },
                                    decisionTypeArray &&
                                        decisionTypeArray.map(function (decisionType, index) { return (react_1.default.createElement("a", { key: index, onClick: function () {
                                                goToRef(index);
                                            }, className: "process-circle process-circle--".concat(decisionType), "data-ng-class": "{'process-circle--selected': $ctrl.focusedJobGroup === index}" }, index + 1)); }),
                                    react_1.default.createElement("div", { className: "eva-jobs-progress-bar-overlay-mask", style: { left: "".concat((focusedJobGroup || 0) * 30 + 3, "px") } },
                                        react_1.default.createElement("div", { className: "eva-jobs-progress-bar-overlay", style: { left: "-".concat((focusedJobGroup || 0) * 30 + 3, "px") } }, decisionTypeArray &&
                                            decisionTypeArray.map(function (decisionType, index) { return (react_1.default.createElement("a", { key: index, className: "process-circle process-circle--".concat(decisionType) }, index + 1)); })))),
                                react_1.default.createElement("div", { className: "js-eva-jobs-submit-btn moderation-queue__submit-button eva-tooltip-container--center" },
                                    react_1.default.createElement("button", { type: "button", className: (0, clsx_1.default)('eva-keyboard-focusable', 'submit-btn-style'), onClick: onSubmit, disabled: isSubmitButtonDisabled || submitLoading, ref: submitButtonRef }, t('MODERATION.QUEUE_VIEW.STATUS_BAR.SUBMIT_BUTTON')),
                                    react_1.default.createElement("span", { className: "eva-tooltip submit-tooltip" }, getSubmitButtonTooltip()))))))))),
        react_1.default.createElement(KeyboardModal_1.default, { isOpen: keyboardModalOpen, setIsOpen: setKeyboardModalOpen })));
}
